export const FROM_HOMEPAGE = 'HOMEPAGE'
export const FROM_PROFESSIONAL_PROFILE = 'PROFESSIONAL_PROFILE'
export const FROM_NPS = 'NPS'